module.exports = __webpack_public_path__ + "static/img/image_solutions_ime_04.82397ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_ime_04.png
// module id = sQl8
// module chunks = 10